// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  apiBase: 'https://demo.lakee1508operation.com/order/zillion',
  apiBasePay: 'https://lpay.lakeetech.com',
  apiBaseAuth: 'https://lvalidate.lakeetech.com',
  production: false,
  defaultauth: 'fackbackend',
  firebaseConfig: {
    apiKey: '',
    authDomain: '',
    databaseURL: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
    measurementId: ''
  },
  AuthToken: {
    merchant_id: 'g8qQvtiK6xSnybj',
    secret_key: 'G6AETVj299yKaYLb8zBc7GfHwjAaVMGWAQdqRzo4l5k='
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
